var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5877 9L17.9975 10.41L4.37939 24H2.99958V22.62L16.5877 9ZM21.9869 0C21.612 0 21.2221 0.15 20.9371 0.435L18.1925 3.18L23.8167 8.805L26.5613 6.06C27.1462 5.475 27.1462 4.5 26.5613 3.945L23.0518 0.435C22.7518 0.135 22.3769 0 21.9869 0ZM16.5877 4.785L0 21.375V27H5.62422L22.2119 10.41L16.5877 4.785Z",
    fill: "#918F8F",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.31665b02ba2b6129a3f2bb64f99f166b.svg";
export { ForwardRef as ReactComponent };